



import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <mask id="mask0_9399_20927" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
      <rect width="20" height="20" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_9399_20927)">
      <path d="M12.7537 13.9148L13.9204 12.7481L10.8371 9.66479V5.83146H9.17041V10.3315L12.7537 13.9148ZM10.0037 18.3315C8.85096 18.3315 7.76763 18.1127 6.75374 17.6752C5.73985 17.2377 4.85791 16.644 4.10791 15.894C3.35791 15.144 2.76416 14.262 2.32666 13.2481C1.88916 12.2342 1.67041 11.1509 1.67041 9.99813C1.67041 8.84535 1.88916 7.76202 2.32666 6.74813C2.76416 5.73424 3.35791 4.85229 4.10791 4.10229C4.85791 3.35229 5.73985 2.75854 6.75374 2.32104C7.76763 1.88354 8.85096 1.66479 10.0037 1.66479C11.1565 1.66479 12.2399 1.88354 13.2537 2.32104C14.2676 2.75854 15.1496 3.35229 15.8996 4.10229C16.6496 4.85229 17.2433 5.73424 17.6808 6.74813C18.1183 7.76202 18.3371 8.84535 18.3371 9.99813C18.3371 11.1509 18.1183 12.2342 17.6808 13.2481C17.2433 14.262 16.6496 15.144 15.8996 15.894C15.1496 16.644 14.2676 17.2377 13.2537 17.6752C12.2399 18.1127 11.1565 18.3315 10.0037 18.3315ZM10.0037 16.6648C11.851 16.6648 13.4239 16.0155 14.7225 14.7169C16.0211 13.4183 16.6704 11.8453 16.6704 9.99813C16.6704 8.15091 16.0211 6.57799 14.7225 5.27938C13.4239 3.98077 11.851 3.33146 10.0037 3.33146C8.15652 3.33146 6.5836 3.98077 5.28499 5.27938C3.98638 6.57799 3.33708 8.15091 3.33708 9.99813C3.33708 11.8453 3.98638 13.4183 5.28499 14.7169C6.5836 16.0155 8.15652 16.6648 10.0037 16.6648Z" className="fill-[#333] dark:fill-white"/>
    </g>
  </svg>
);

export default Icon;
